export const BUSINESS_PARTNER_SIDEBAR_TRANSLATION_DE = {
  open_bpc: 'Business Partner Center öffnen',
};
